class CustomComponent {
  constructor(element) {
    this._element = element;
    this._button = this._element.querySelector('.custom-button');
    this._addListeners = this._addListeners.bind(this);
    this._addListeners();
  }

  _addListeners() {
    this._button.addEventListener('click', () => {
      // eslint-disable-next-line no-console
      console.log('click');
      // eslint-disable-next-line no-alert
      alert('click');
    });
  }
}

export default CustomComponent;
